import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: theme.mixins.gutters({
    textAlign: 'center',
    minHeight: '70vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    '& h1': {
      fontSize: '2.5rem',
      lineHeight: '1.5rem',
      fontWeight: 600,
      color: '#596375',
    },
    '& h2': {
      fontSize: '1rem',
      color: '#596375',
    },
  }),
}));

interface IProps {
  resetErrorState: () => void;
}

const Error = ({ resetErrorState }: IProps) => {
  const classes = useStyles();

  const handleNavigateToMain = () => {
    resetErrorState();
  };

  return (
    <div>
      <div className={classes.root}>
        <div className='notfound'>
          <h1>Tente novamente</h1>
          <br />
          <h2>A página não pode ser carregada. Tente novamente mais tarde.</h2>
          <br />
        </div>
        <Link to='/' onClick={handleNavigateToMain}>
          <Button color='primary' variant='contained'>
            Ir para tela principal
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default Error;
